// Option keys without the `absence:` prefix, per docs/specs/feedback-round-2026-10-20.md D3.
const IMPORTANT_ABSENCE_TYPE_KEYS: readonly string[] = [
  'vacation',
  'sick_day',
  'globetrotter_non_sales_time',
  'compensatory',
  'globetrotter_paid_absence',
  'globetrotter_training',
  'globetrotter_apprentice_support',
];

interface AbsenceTypeSortable {
  key: string;
  label: string;
}

function importanceRankOf(key: string): number {
  const index = IMPORTANT_ABSENCE_TYPE_KEYS.indexOf(key);
  return index === -1 ? IMPORTANT_ABSENCE_TYPE_KEYS.length : index;
}

export function absenceTypeComparator(language: string): (left: AbsenceTypeSortable, right: AbsenceTypeSortable) => number {
  return (left, right) => importanceRankOf(left.key) - importanceRankOf(right.key) || left.label.localeCompare(right.label, language);
}
